import { useQuery } from '@tanstack/react-query'
import { fetchReferralMyLink } from '../referral'

export const referralMyLinkQueryKey = ['referral', 'my-link'] as const

export const referralMyLinkQueryOptions = (enabled = true) => ({
  queryKey: referralMyLinkQueryKey,
  queryFn: () => fetchReferralMyLink(undefined),
  enabled
})

export const useReferralMyLink = (enabled = true) => useQuery(referralMyLinkQueryOptions(enabled))
